import { addApiPrefix } from 'as-ui-kit/utils/urls';
import {getFetchOptions, handleResult} from 'as-ui-kit/utils/http';
import { snakeToPascalObj } from 'as-ui-kit/utils/adapters';
import { catchWithMsg } from 'utils/http';
import {apiUrl} from 'urls';

export const getBoardsForFirms = (atiIds) =>
    fetch(addApiPrefix('/boards/v2/boards/frontend/board/myforfirms', apiUrl), getFetchOptions(atiIds, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const inviteFirmsToBoards = (inviteToBoards) =>
    fetch(addApiPrefix('/boards/v2/boards/frontend/invite/massToBoards/', apiUrl), getFetchOptions(inviteToBoards, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

